<template>
  <module-page v-bind="pageParams">
    <div v-show="!iframeError">
      <p class="construction-progress__description">
        {{ pageParams.texts.description }}
      </p>
      <iframe
        v-if="url"
        ref="iframe"
        class="construction-progress__iframe"
        :src="url"
      />
    </div>
    <empty-state-card
      v-if="iframeError"
      :message="$t('responses.error')"
      icon="alert"
    ></empty-state-card>
  </module-page>
</template>

<script>
import ModulePage from '@/components/layout/Page';
import EmptyStateCard from '@/components/layout/EmptyStateCard.vue';
import { APP, IFRAME } from '../../utils/constants';
export default {
  name: 'constructionProgress',
  components: {
    ModulePage,
    EmptyStateCard,
  },
  computed: {
    url(){
      return this.$store.getters[IFRAME.GET_CONSTRUCTION_PAGE_URL];
    }
  },
  data() {
    return {
      pageParams: {},
      iframeError: false,
    };
  },
  created() {
    this.pageParams = this.$store.getters[APP.PAGES].constructionProgress;
  }
};
</script>
<style lang="scss" scoped>
.construction-progress {
  &__description {
    font-size: 0.75em;
    color: var(--label-color);
  }

  &__iframe {
    width: 100%;
    height: 100%;
    min-height: 500px;
    border: none;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/product/ConstructionProgress.vue